import { ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {  ListService, SubListComponent, UserGroupAssignedPermissionsListService } from '@spartacus/organization/administration/components';
import { EfaOrgCardComponent } from '../efa-org-card/efa-org-card.component';
import { FocusDirective, TableComponent, PaginationComponent } from '@spartacus/storefront';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe } from '@spartacus/core';


@Component({
    selector: 'app-efa-sub-list',
    templateUrl: './efa-sub-list.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'content-wrapper' },
    imports: [EfaOrgCardComponent, FocusDirective, TableComponent, PaginationComponent, AsyncPipe, TranslatePipe]
})
export class EfaSubListComponent extends SubListComponent implements OnInit {


  ngOnInit(): void {
  }

}
